import React, { useRef,useState } from "react";
import { FormControl, Card, Layout, Button, usePath, CardBody, useAppConfig } from "@fdoh/health-ui-react";
import { useHistory, Link } from "react-router-dom";
import { useSubmitForm } from "../../hooks/useSubmitForm";
import { useForm } from "react-hook-form";
import { TankInstallationInput, schema, TankInstallationFormProps, ComplianceData, TankMaterialData, LegendData, OutletFilterData, AtuMakeData } from "./TankInstallationForm.types";
import { useData } from "../../hooks";
import { yupResolver } from "@hookform/resolvers/yup";
import CSS from 'csstype';
import { Constants, InspectionStatus } from "../../helpers/Constants";
import { toast } from "react-toastify";
import { InspectionStatusInput } from "../InspectionHome/InspectionHome.types";
import useProfile from "../../hooks/useProfile";
import { UserSecurityInput } from "../../components/DBProtectedRoute.types";


let showTank2: boolean = false;

export const TankInstallationForm = (props: TankInstallationFormProps) => {
    const history = useHistory();
    const path = usePath();
    const complianceData = useData<ComplianceData[]>("Compliance") || [];
    const tankMaterialData = useData<TankMaterialData[]>("TankMaterial") || [];
    const legendData = useData<LegendData[]>("Legend") || [];
    const outletFilterData = useData<OutletFilterData[]>("OutletFilter") || [];
    const atuMakeLookupData = useData<AtuMakeData[]>("AtuMake") || [];
    const yesNoData = [
        { id: "", name: "Please select a value" },
        { id: "Yes", name: "Yes" },
        { id: "No", name: "No" }
    ];
    const tankUnitData = [
        { id: "", name: "Please select a value" },
        { id: "Gallons", name: "Gallons" },
        { id: "GPD", name: "GPD" }
    ];
    const atuMakeData = [
        { id: "", name: "Please select a value" },
        ...atuMakeLookupData
            .filter(x => x.name && x.name !== "Please select a value")
            .map(x => ({ id: x.id, name: x.name }))
    ];
   // const [showTank2, setTank2] = useState(false);
    const inspectionStatusData = useData<InspectionStatusInput>("inspectionDetails/" + props.applicationInspectionId);

    const getSelectDefaultValue = (value: any) => {
        return value === null || value === undefined ? "" : value;
    };

    const defaultvalues = {
        ...props.values,
        units: getSelectDefaultValue(props.values?.units),
        multiChambered: getSelectDefaultValue(props.values?.multiChambered),
        tanksInSeries1: getSelectDefaultValue(props.values?.tanksInSeries1),
        atuMakeId: getSelectDefaultValue(props.values?.atuMakeId),
        units2: getSelectDefaultValue(props.values?.units2),
        multiChambered2: getSelectDefaultValue(props.values?.multiChambered2),
        tanksInSeries2: getSelectDefaultValue(props.values?.tanksInSeries2),
        atuMakeId2: getSelectDefaultValue(props.values?.atuMakeId2),
        riser2: getSelectDefaultValue(props.values?.riser2),
        dateCreated: props.values?.dateCreated ? new Date(props.values.dateCreated).toLocaleString().slice(0, 10) : undefined
    }
    const { control, handleSubmit, setValue, watch } = useForm<TankInstallationInput>({
        resolver: yupResolver(schema),
        defaultValues: defaultvalues,
    });
    const formRef = useRef<HTMLFormElement>(null);
    const config =  useAppConfig();
    const application = config.applications.filter(x => x.name === "privateProviderInspectionApi")[0];
   
      const user =  useProfile(application) as UserSecurityInput;
    function timeout(delay: number) {
        return new Promise(res => setTimeout(res, delay));
    }

    const onSubmit = useSubmitForm<TankInstallationInput>(
        'tankInstallation',
        async (response) => {
            toast.success("Tank Installation Saved Successfully");
            await timeout(2000);
            let inspectionStatus = watch("inspectionStatusId");
        if(inspectionStatus == InspectionStatus.Complete){
            if(inspectionStatusData?.drainfieldInstallationInspectionId == null 
                || inspectionStatusData?.drainfieldInstallationInspectionId == undefined){
                    history.push({
                        pathname: "/drainfieldInstallation/",
                        search: `?applicationId=${inspectionStatusData?.applicationId}&inspectionId=${inspectionStatusData?.applicationInspectionId}`,
                    })
                }
                else {
                    history.push({
                        pathname: "/drainfieldInstallation/"+ inspectionStatusData?.drainfieldInstallationId,
                        search: `?applicationId=${inspectionStatusData?.applicationId}&inspectionId=${inspectionStatusData?.applicationInspectionId}`,
                    })
                }
        }
        else if (inspectionStatus == InspectionStatus.Incomplete){
            history.push(`/inspectionDetails/${inspectionStatusData?.applicationInspectionId}`) ;
        }
        },
        props.action
    );


    const removeClick = (e: any) => {
      
        e.preventDefault();
    };


    const submit = () => {
        setValue('applicationInspectionId', props.applicationInspectionId ? props.applicationInspectionId : 0);
       
       if(inspectionStatusData?.tankInstallationInspectionId == null 
        || inspectionStatusData?.tankInstallationInspectionId == undefined){
            setValue('dateCreated', new Date());
            setValue('createdBy', user?.userName);
        }
        else {
            setValue('dateUpdated', new Date());
            setValue('updatedBy', user?.userName);
        }
       // setValue('isTank2', showTank2);

        const selectedUnits = watch('units');
        const selectedMultiChambered = watch('multiChambered');
        const selectedTanksInSeries1 = watch('tanksInSeries1');
        const selectedAtuMakeId = watch('atuMakeId');

        setValue('units', selectedUnits === "" ? null as any : selectedUnits);
        setValue('multiChambered', selectedMultiChambered === "" ? null as any : selectedMultiChambered as any);
        setValue('tanksInSeries1', selectedTanksInSeries1 === "" ? null as any : selectedTanksInSeries1 as any);
        setValue('atuMakeId', selectedAtuMakeId == null || Number(selectedAtuMakeId) === 0 ? null as any : Number(selectedAtuMakeId) as any);

        if (showTank == false)
        {
            setValue('tank2ComplianceId', 0);
            setValue('tankSize2', 1);
            setValue('tank2SizeComment', 'Remove Tank-2');

            setValue('tank2MaterialComplianceId', 0);
            setValue('tankMaterialId2', 0);
            setValue('tank2MaterialComment', 'Remove Tank-2');

            setValue('tank2LegendComplianceId', 0);
            setValue('legendId2', 0);
            setValue('tank2LegendComment', 'Remove Tank-2');
        }
        else
        {
            const selectedUnits2 = watch('units2');
            const selectedMultiChambered2 = watch('multiChambered2');
            const selectedTanksInSeries2 = watch('tanksInSeries2');
            const selectedAtuMakeId2 = watch('atuMakeId2');
            const selectedRiser2 = watch('riser2');

            setValue('units2', selectedUnits2 === "" ? null as any : selectedUnits2 as any);
            setValue('multiChambered2', selectedMultiChambered2 === "" ? null as any : selectedMultiChambered2 as any);
            setValue('tanksInSeries2', selectedTanksInSeries2 === "" ? null as any : selectedTanksInSeries2 as any);
            setValue('atuMakeId2', selectedAtuMakeId2 == null || Number(selectedAtuMakeId2) === 0 ? null as any : Number(selectedAtuMakeId2) as any);
            setValue('riser2', selectedRiser2 === "" ? null as any : selectedRiser2 as any);
        }





		if (formRef.current) {
           
			formRef.current.dispatchEvent(
				new Event('submit', { cancelable: true, bubbles: true })
			);
            
		}
    }


    let showTankSizeComment = watch("tankComplianceId");
    let showAtuPbts = watch("atuPbtsComplianceId");
    let showTankMaterialComment = watch("tankMaterialComplianceId");
    let showOutletDeviceComment = watch("outletDeviceComplianceId");
    let showMultiChamberedComment = watch("multiChamberedComplianceId");
    let showOutletFilterComment = watch("outletFilterComplienceId");
    let showLegendComment = watch("legendComplianceId");
    let showWatertightComment = watch("watertightComplianceId");
    let showLevelComment = watch("levelComplianceId");
    let showDepthToLidComment = watch("depthToLidComplianceId");
    let showTank2SizeComment = watch("tank2ComplianceId");
    let showTank2MaterialComment = watch("tank2MaterialComplianceId");
    let showTank2LegendComment = watch("tank2LegendComplianceId");
    let showTank2AtuPbts = watch("atuPbtsComplianceId2");
    let showTank2OutletDeviceComment = watch("outletDeviceComplianceId2");
    let showTank2MultiChamberedComment = watch("multiChamberedComplianceId2");
    let showTank2OutletFilterComment = watch("outletFilterComplienceId2");
    let showTank2WatertightComment = watch("watertightComplianceId2");
    let showTank2LevelComment = watch("levelComplianceId2");
    let showTank2DepthToLidComment = watch("depthToLidComplianceId2");
    let markAllCompliance = watch("markAll");
    let showTank = watch("isTank2Showable");
    //setTank2(showTank);
    const h1Styles: CSS.Properties = {
        float: "right",
       marginTop: '27px'
      };
  const markClick = (e: any) => {
      setValue('tankComplianceId', markAllCompliance);
      setValue('atuPbtsComplianceId', markAllCompliance);
      setValue('tankMaterialComplianceId', markAllCompliance);
      setValue('outletDeviceComplianceId', markAllCompliance);
      setValue('multiChamberedComplianceId', markAllCompliance);
      setValue('outletFilterComplienceId', markAllCompliance);
      setValue('legendComplianceId', markAllCompliance);
      setValue('watertightComplianceId', markAllCompliance);
      setValue('levelComplianceId', markAllCompliance);
      setValue('depthToLidComplianceId', markAllCompliance);
      if (showTank == true)
      {
      setValue('tank2ComplianceId', markAllCompliance);
      setValue('tank2MaterialComplianceId', markAllCompliance);
      setValue('tank2LegendComplianceId', markAllCompliance);
      setValue('atuPbtsComplianceId2', markAllCompliance);
      setValue('outletDeviceComplianceId2', markAllCompliance);
      setValue('multiChamberedComplianceId2', markAllCompliance);
      setValue('outletFilterComplienceId2', markAllCompliance);
      setValue('watertightComplianceId2', markAllCompliance);
      setValue('levelComplianceId2', markAllCompliance);
      setValue('depthToLidComplianceId2', markAllCompliance);
      }

    e.preventDefault();
      };
     
    return (
        <form id={props.id} ref={formRef} onSubmit={handleSubmit((data:TankInstallationInput) => onSubmit(data))}>
            <div className="row">
                <div className="col col-md-8">
                    <div className="card-main-title">
                        Tank Installation
                    </div>
                </div>
                <div className="col col-md-3">
                    <FormControl.Select
                        control={control}
                        name="markAll"
                        label="Mark All"
                        options={complianceData}
                        required
                    />
                </div>
                <div className="col col-md-1" style={h1Styles}>
                    <Button name="markAll" className="btn btn-primary" onClick={markClick} >Apply</Button>
                </div>
            </div>
           
            <Card.Container>
          
                <Card.Header>
                <Card.Title>{props.title}</Card.Title>
                </Card.Header>

                <Card.Body>
                    {/*  ============================================================================================================================================*/}
                    <Layout.Row>   <>
                        <div className="row">
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="tankComplianceId"
                                    label="Tank Size"
                                    options={complianceData}
                                    required
                                />
                            </div>
                            <div className="col col-md-4">
                                <FormControl.Text
                                    control={control}
                                    name="tankSize1"
                                    label="Tank Size"
                                    required= {showTankSizeComment != Constants.Not_Applicable && showTankSizeComment !=Constants.Unobserved }
                                />
                            </div>
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="units"
                                    label="Units (gal/gpd)"
                                    options={tankUnitData}
                                    required={showTankSizeComment != Constants.Not_Applicable && showTankSizeComment != Constants.Unobserved}
                                />
                            </div>
                        </div>
                    
                              
                           
                        {showTankSizeComment &&
                            showTankSizeComment == 3 && (
                                <div className="row">
                                    <div className="col col-md-12">
                                        <FormControl.TextArea
                                            control={control}
                                        name="tankSizeComment"
                                            label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)"
                                            required
                                        />
                                    </div>
                                </div>
                            )}
                      {/*  ============================================================================================================================================*/}
                        <div className="row">
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="atuPbtsComplianceId"
                                    label="ATU/PBTS"
                                    options={complianceData}
                                    required
                                />
                            </div>
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="atuMakeId"
                                    label="Make and Model"
                                    options={atuMakeData}
                                    required={showAtuPbts != Constants.Not_Applicable && showAtuPbts != Constants.Unobserved}
                                />
                            </div>
                        </div>
                        {showAtuPbts &&
                            showAtuPbts == Constants.Out_of_Compliance && (
                                <div className="row">
                                    <div className="col col-md-12">
                                        <FormControl.TextArea
                                            control={control}
                                            name="atuPbtsComment"
                                            label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)"
                                            required
                                        />
                                    </div>
                                </div>
                            )}
                      {/*  ============================================================================================================================================*/}
                        <div className="row">
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="tankMaterialComplianceId"
                                    label="Tank Material" 
                                    options={complianceData}
                                    required
                                />
                            </div>
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="tankMaterialId1"
                                    label="Tank Material Type"
                                    options={tankMaterialData}
                                    required= {showTankMaterialComment != Constants.Not_Applicable && showTankMaterialComment !=Constants.Unobserved }
                                />
                            </div>
                            {(Number(watch("tankMaterialId1")) === -1 || Number(watch("tankMaterialId1")) === 6 || Number(watch("tankMaterialId1")) === 9) && (
                                <div className="col col-md-4">
                                    <FormControl.Text
                                        control={control}
                                        name="tankMaterialOtherDescription"
                                        label="Other (Description)"
                                        placeholder="Please describe the material type"
                                        required={showTankMaterialComment != Constants.Not_Applicable && showTankMaterialComment != Constants.Unobserved}
                                    />
                                </div>
                            )}
                        </div>
                        {showTankMaterialComment &&
                            showTankMaterialComment == 3 && (
                                <div className="row">
                                    <div className="col col-md-12">
                                        <FormControl.TextArea
                                            control={control}
                                        name="tankMaterialComment"
                                            label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)"
                                            required
                                        />
                                    </div>
                                </div>
                            )}
                        {/*  ============================================================================================================================================*/}
                        <div className="row">
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="outletDeviceComplianceId"
                                    label="Inlet / Outlet Device"
                                    options={complianceData}
                                    required
                                />
                            </div>
                           
                        </div>
                        {showOutletDeviceComment &&
                            showOutletDeviceComment == 3 && (
                                <div className="row">
                                    <div className="col col-md-12">
                                        <FormControl.TextArea
                                            control={control}
                                        name="outletDeviceComment"
                                            label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)"
                                            required
                                        />
                                    </div>
                                </div>
                            )}
                        {/*  ============================================================================================================================================*/}
                        <div className="row">
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="multiChamberedComplianceId"
                                    label="Tank Multichambered"
                                    options={complianceData}
                                    required
                                />
                            </div>
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="multiChambered"
                                    label="Is Tank Multichambered?"
                                    options={yesNoData}
                                    required= {showMultiChamberedComment != Constants.Not_Applicable && showMultiChamberedComment !=Constants.Unobserved }
                                />
                            </div>
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="tanksInSeries1"
                                    label="Tanks In Series?"
                                    options={yesNoData}
                                    required={showMultiChamberedComment != Constants.Not_Applicable && showMultiChamberedComment != Constants.Unobserved}
                                />
                            </div>
                        </div>
                        {showMultiChamberedComment &&
                            showMultiChamberedComment == 3 && (
                                <div className="row">
                                    <div className="col col-md-12">
                                        <FormControl.TextArea
                                            control={control}
                                        name="multiChamberedComment"
                                            label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)"
                                            required
                                        />
                                    </div>
                                </div>
                            )}
                        {/*  ============================================================================================================================================*/}
                        <div className="row">
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="outletFilterComplienceId"
                                    label="Tank Outlet Filter"
                                    options={complianceData}
                                    required
                                />
                            </div>
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="outletFilterId"
                                    label="Outlet Filter Make & Model"
                                    options={outletFilterData}
                                    required= {showOutletFilterComment != Constants.Not_Applicable && showOutletFilterComment != Constants.Out_of_Compliance && showOutletFilterComment !=Constants.Unobserved }
                                />
                            </div>
                        </div>
                        {showOutletFilterComment &&
                            showOutletFilterComment == 3 && (
                                <div className="row">
                                    <div className="col col-md-12">
                                        <FormControl.TextArea
                                            control={control}
                                        name="outletFilterComment"
                                            label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)"
                                            required
                                        />
                                    </div>
                                </div>
                            )}
                        {/*  ============================================================================================================================================*/}
                        <div className="row">
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="legendComplianceId"
                                    label="Tank Legend"
                                    options={complianceData}
                                    required
                                />
                            </div>
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="legendId1"
                                    label="Tank Legend Number"
                                    options={legendData}
                                    required={showLegendComment != Constants.Not_Applicable
                                        && showLegendComment != Constants.Unobserved}
                                />
                            </div>
                        </div>
                        {showLegendComment &&
                            showLegendComment == 3 && (
                                <div className="row">
                                    <div className="col col-md-12">
                                        <FormControl.TextArea
                                            control={control}
                                        name="legendComment"
                                            label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)"
                                            required
                                        />
                                    </div>
                                </div>
                            )}
                        {/*  ============================================================================================================================================*/}
                        <div className="row">
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="watertightComplianceId"
                                    label="Watertight"
                                    options={complianceData}
                                    required
                                />
                            </div>
                          
                        </div>
                        {showWatertightComment &&
                            showWatertightComment == 3 && (
                                <div className="row">
                                    <div className="col col-md-12">
                                        <FormControl.TextArea
                                            control={control}
                                        name="watertightComment"
                                            label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)"
                                            required
                                        />
                                    </div>
                                </div>
                            )}
                        {/*  ============================================================================================================================================*/}
                        <div className="row">
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="levelComplianceId"
                                    label="Level"
                                    options={complianceData}
                                    required
                                />
                            </div>
                           
                        </div>
                        {showLevelComment &&
                            showLevelComment == 3 && (
                                <div className="row">
                                    <div className="col col-md-12">
                                        <FormControl.TextArea
                                            control={control}
                                        name="levelComment"
                                            label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)"
                                            required
                                        />
                                    </div>
                                </div>
                            )}
                        {/*  ============================================================================================================================================*/}
                        <div className="row">
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="depthToLidComplianceId"
                                    label="Depth to Lid"
                                    options={complianceData}
                                    required
                                />
                            </div>
                            <div className="col col-md-4">
                                <FormControl.Text
                                    control={control}
                                    name="depthToLid"
                                    label="Depth to Lid (inches)"
                                    required={showDepthToLidComment != Constants.Not_Applicable && showDepthToLidComment != Constants.Unobserved}
                                />
                            </div>
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="riser"
                                    label="Riser(s)"
                                    options={yesNoData}
                                    required={showDepthToLidComment != Constants.Not_Applicable && showDepthToLidComment != Constants.Unobserved}
                                />
                            </div>
                        </div>
                        {showDepthToLidComment &&
                            showDepthToLidComment == 3 && (
                                <div className="row">
                                    <div className="col col-md-12">
                                        <FormControl.TextArea
                                            control={control}
                                        name="depthToLidComment"
                                            label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)"
                                            required
                                        />
                                    </div>
                                </div>
                            )}
                     
                     
                        <div className="row">
                           
                            <div className="col col-md-4" hidden>
                                <FormControl.Text
                                    control={control}
                                    name="inspectionStatusId"
                                    label="Inspection StatusId"
                                    required
                                />
                            </div>
                            
                        </div>
                        {/*  ============================================================================================================================================*/}
                    </></Layout.Row>
                </Card.Body>



                <div hidden={showTank}>
                    <Button id="showme" className="btn btn-primary ms-auto" onClick={(e) => { e.preventDefault(); setValue('isTank2Showable', true); }}>Add Tank</Button>
                </div>
                {
                   showTank && (<Card.Body>
                        {/*  ============================================================================================================================================*/}
                        {/*                                                     Tank 2                                                                                   */}
                        {/*  ============================================================================================================================================*/}

                        <div className="row mb-4">
                            <div className="col col-md-8">
                                <div className="d-flex align-items-center">
                                    <div className="bg-primary text-white rounded-circle d-flex align-items-center justify-content-center me-3" style={{ width: 40, height: 40 }}>
                                        <span className="fw-bold">2</span>
                                    </div>
                                    <div>
                                        <h3 className="text-primary mb-1 fw-bold">Tank 2</h3>
                                        <p className="text-muted mb-0">Additional tank installation details</p>
                                    </div>
                                </div>
                            </div>
                            <div className="col col-md-4 text-end">
                                <button className="btn btn-danger" onClick={(e) => { e.preventDefault(); setValue('isTank2Showable', false); }}>
                                    <svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-trash me-1" width="18" height="18" viewBox="0 0 24 24" strokeWidth="2" stroke="currentColor" fill="none" strokeLinecap="round" strokeLinejoin="round">
                                        <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                        <path d="M4 7l16 0"></path>
                                        <path d="M10 11l0 6"></path>
                                        <path d="M14 11l0 6"></path>
                                        <path d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12"></path>
                                        <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3"></path>
                                    </svg>
                                    Remove Tank
                                </button>
                            </div>
                        </div>

                        {/*  ============================================================================================================================================*/}
                        <div className="row border-top border-2 border-primary pt-4">
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="tank2ComplianceId"
                                    label="Tank Size"
                                    options={complianceData}
                                    required
                                />
                            </div>
                            <div className="col col-md-4">
                                <FormControl.Text
                                    control={control}
                                    name="tankSize2"
                                    label="Tank Size"
                                    required={showTank2SizeComment != Constants.Not_Applicable
                                        && showTank2SizeComment != Constants.Unobserved}
                                />
                            </div>
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="units2"
                                    label="Units (gal/gpd)"
                                    options={tankUnitData}
                                    required={showTank2SizeComment != Constants.Not_Applicable && showTank2SizeComment != Constants.Unobserved}
                                />
                            </div>
                        </div>
                        {showTank2SizeComment &&
                            showTank2SizeComment == 3 && (
                                <div className="row">
                                    <div className="col col-md-12">
                                        <FormControl.TextArea
                                            control={control}
                                            name="tank2SizeComment"
                                            label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)"
                                            required
                                        />
                                    </div>
                                </div>
                            )}
                        {/*  ============================================================================================================================================*/}
                        <div className="row">
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="atuPbtsComplianceId2"
                                    label="ATU/PBTS"
                                    options={complianceData}
                                    required
                                />
                            </div>
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="atuMakeId2"
                                    label="Make and Model"
                                    options={atuMakeData}
                                    required={showTank2AtuPbts != Constants.Not_Applicable && showTank2AtuPbts != Constants.Unobserved}
                                />
                            </div>
                        </div>
                        {showTank2AtuPbts &&
                            showTank2AtuPbts == Constants.Out_of_Compliance && (
                                <div className="row">
                                    <div className="col col-md-12">
                                        <FormControl.TextArea
                                            control={control}
                                            name="atuPbtsComment2"
                                            label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)"
                                            required
                                        />
                                    </div>
                                </div>
                            )}
                        {/*  ============================================================================================================================================*/}
                        <div className="row">
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="tank2MaterialComplianceId"
                                    label="Tank Material"
                                    options={complianceData}
                                    required
                                />
                            </div>
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="tankMaterialId2"
                                    label="Tank Material Type"
                                    options={tankMaterialData}
                                    required={showTank2MaterialComment != Constants.Not_Applicable
                                        && showTank2MaterialComment != Constants.Unobserved}
                                />
                            </div>
                            {(Number(watch("tankMaterialId2")) === -1 || Number(watch("tankMaterialId2")) === 6 || Number(watch("tankMaterialId2")) === 9) && (
                                <div className="col col-md-4">
                                    <FormControl.Text
                                        control={control}
                                        name="tank2MaterialOtherDescription"
                                        label="Other (Description)"
                                        placeholder="Please describe the material type"
                                        required={showTank2MaterialComment != Constants.Not_Applicable
                                            && showTank2MaterialComment != Constants.Unobserved}
                                    />
                                </div>
                            )}
                        </div>
                        {showTank2MaterialComment &&
                            showTank2MaterialComment == 3 && (
                                <div className="row">
                                    <div className="col col-md-12">
                                        <FormControl.TextArea
                                            control={control}
                                            name="tank2MaterialComment"
                                            label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)"
                                            required
                                        />
                                    </div>
                                </div>
                            )}
                        {/*  ============================================================================================================================================*/}
                        <div className="row">
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="outletDeviceComplianceId2"
                                    label="Inlet / Outlet Device"
                                    options={complianceData}
                                    required
                                />
                            </div>
                        </div>
                        {showTank2OutletDeviceComment &&
                            showTank2OutletDeviceComment == 3 && (
                                <div className="row">
                                    <div className="col col-md-12">
                                        <FormControl.TextArea
                                            control={control}
                                            name="outletDeviceComment2"
                                            label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)"
                                            required
                                        />
                                    </div>
                                </div>
                            )}
                        {/*  ============================================================================================================================================*/}
                        <div className="row">
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="multiChamberedComplianceId2"
                                    label="Tank Multichambered"
                                    options={complianceData}
                                    required
                                />
                            </div>
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="multiChambered2"
                                    label="Is Tank Multichambered?"
                                    options={yesNoData}
                                    required={showTank2MultiChamberedComment != Constants.Not_Applicable && showTank2MultiChamberedComment != Constants.Unobserved}
                                />
                            </div>
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="tanksInSeries2"
                                    label="Tanks In Series?"
                                    options={yesNoData}
                                    required={showTank2MultiChamberedComment != Constants.Not_Applicable && showTank2MultiChamberedComment != Constants.Unobserved}
                                />
                            </div>
                        </div>
                        {showTank2MultiChamberedComment &&
                            showTank2MultiChamberedComment == 3 && (
                                <div className="row">
                                    <div className="col col-md-12">
                                        <FormControl.TextArea
                                            control={control}
                                            name="multiChamberedComment2"
                                            label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)"
                                            required
                                        />
                                    </div>
                                </div>
                            )}
                        {/*  ============================================================================================================================================*/}
                        <div className="row">
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="outletFilterComplienceId2"
                                    label="Tank Outlet Filter"
                                    options={complianceData}
                                    required
                                />
                            </div>
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="outletFilterId2"
                                    label="Outlet Filter Make & Model"
                                    options={outletFilterData}
                                    required={showTank2OutletFilterComment != Constants.Not_Applicable && showTank2OutletFilterComment != Constants.Out_of_Compliance && showTank2OutletFilterComment != Constants.Unobserved}
                                />
                            </div>
                        </div>
                        {showTank2OutletFilterComment &&
                            showTank2OutletFilterComment == 3 && (
                                <div className="row">
                                    <div className="col col-md-12">
                                        <FormControl.TextArea
                                            control={control}
                                            name="outletFilterComment2"
                                            label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)"
                                            required
                                        />
                                    </div>
                                </div>
                            )}
                        {/*  ============================================================================================================================================*/}
                        <div className="row">
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="tank2LegendComplianceId"
                                    label="Tank Legend"
                                    options={complianceData}
                                    required
                                />
                            </div>
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="legendId2"
                                    label="Tank Legend Number"
                                    options={legendData}
                                    required={showTank2LegendComment != Constants.Not_Applicable
                                        && showTank2LegendComment != Constants.Unobserved}
                                />
                            </div>
                        </div>
                        {showTank2LegendComment &&
                            showTank2LegendComment == 3 && (
                                <div className="row">
                                    <div className="col col-md-12">
                                        <FormControl.TextArea
                                            control={control}
                                            name="tank2LegendComment"
                                            label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)"
                                            required
                                        />
                                    </div>
                                </div>
                            )}
                        {/*  ============================================================================================================================================*/}
                        <div className="row">
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="watertightComplianceId2"
                                    label="Watertight"
                                    options={complianceData}
                                    required
                                />
                            </div>
                        </div>
                        {showTank2WatertightComment &&
                            showTank2WatertightComment == 3 && (
                                <div className="row">
                                    <div className="col col-md-12">
                                        <FormControl.TextArea
                                            control={control}
                                            name="watertightComment2"
                                            label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)"
                                            required
                                        />
                                    </div>
                                </div>
                            )}
                        {/*  ============================================================================================================================================*/}
                        <div className="row">
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="levelComplianceId2"
                                    label="Level"
                                    options={complianceData}
                                    required
                                />
                            </div>
                        </div>
                        {showTank2LevelComment &&
                            showTank2LevelComment == 3 && (
                                <div className="row">
                                    <div className="col col-md-12">
                                        <FormControl.TextArea
                                            control={control}
                                            name="levelComment2"
                                            label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)"
                                            required
                                        />
                                    </div>
                                </div>
                            )}
                        {/*  ============================================================================================================================================*/}
                        <div className="row">
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="depthToLidComplianceId2"
                                    label="Depth to Lid"
                                    options={complianceData}
                                    required
                                />
                            </div>
                            <div className="col col-md-4">
                                <FormControl.Text
                                    control={control}
                                    name="depthToLid2"
                                    label="Depth to Lid (inches)"
                                    required={showTank2DepthToLidComment != Constants.Not_Applicable && showTank2DepthToLidComment != Constants.Unobserved}
                                />
                            </div>
                            <div className="col col-md-4">
                                <FormControl.Select
                                    control={control}
                                    name="riser2"
                                    label="Riser(s)"
                                    options={yesNoData}
                                    required={showTank2DepthToLidComment != Constants.Not_Applicable && showTank2DepthToLidComment != Constants.Unobserved}
                                />
                            </div>
                        </div>
                        {showTank2DepthToLidComment &&
                            showTank2DepthToLidComment == 3 && (
                                <div className="row">
                                    <div className="col col-md-12">
                                        <FormControl.TextArea
                                            control={control}
                                            name="depthToLidComment2"
                                            label="Explanation of Compliance Violation (upload any related sketches or documentation on the final submission page)"
                                            required
                                        />
                                    </div>
                                </div>
                            )}
                        {/*  ============================================================================================================================================*/}
                    </Card.Body>)

                }


                {/*=======================================================================================================================================================*/}
                <Card.Footer>
                    <div className="d-flex">
                        <span className="btn btn-link" onClick={(e) => {
                            e.preventDefault();
                            setValue('inspectionStatusId', InspectionStatus.Incomplete);
                            submit()

                        }}><svg xmlns="http://www.w3.org/2000/svg" className="icon icon-tabler icon-tabler-circle-arrow-left" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                <path d="M12 21a9 9 0 1 0 0-18 9 9 0 0 0 0 18"></path>
                                <path d="M8 12l4 4"></path><path d="M8 12h8"></path>
                                <path d="M12 8l-4 4"></path>
                            </svg> Save and Exit
                        </span>                       
                        <div className="btn-list ms-auto">
                            <Link
                                to={props.returnPath ?? path.current}
                                className="btn btn-light"
                                role="button"
                            >
                                Cancel
                            </Link>
                            <Button className="btn btn-primary ms-auto" onClick={(e) => {
                                e.preventDefault();
                                setValue('inspectionStatusId', InspectionStatus.Complete);
                                submit()

                            }}>Next</Button>
                        </div>                        
                    </div>
                </Card.Footer>
            </Card.Container>

            
        </form>
    );
};

export default TankInstallationForm;




